import { Component, OnInit, QueryList, ViewChildren } from '@angular/core';
import { ToastrService } from 'ngx-toastr';
import { FormBuilder, FormControl, FormGroup, Validators } from '@angular/forms';
import { NgxSpinnerService } from 'ngx-spinner';
import { ApiResponse, SortEvent } from 'src/app/shareModule/models/common.model';
import { AuthServiceService } from 'src/app/shareModule/services/auth-service.service';
import { Member } from '../../admin-members-analytics/admin-members-analytics.model';
import { CommonService } from '../../../shareModule/services/common.service';
import { NgbdSortableHeader } from 'src/app/shareModule/directive/ngbd-sortable-header/ngbd-sortable-header.directive';
import { LabelType, Options } from '@angular-slider/ngx-slider';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';

export interface Quests {
  name: string;
  type: string;
  message: string;
  expiry: number;
}

export const QUEST_STATUS = {
  0: 'pending',
  1: 'completed',
  2: 'expired',
  3: 'accepted',
  4: 'failed',
};

@Component({
  selector: 'app-quests',
  templateUrl: './quests.component.html',
  styleUrls: ['./quests.component.scss'],
})
export class QuestsComponent implements OnInit {
  value: number = 0;
  highValue: number = 100;
  options: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>Level:</b>' + value;
        case LabelType.High:
          return '<b>Level:</b>' + value;
        default:
          return '' + value;
      }
    },
  };
  optionsQuestLevel: Options = {
    floor: 0,
    ceil: 100,
    translate: (value: number, label: LabelType): string => {
      switch (label) {
        case LabelType.Low:
          return '<b>Level:</b>' + value;
        case LabelType.High:
          return '<b>Level:</b>' + value;
        default:
          return '' + value;
      }
    },
  };

  public form: FormGroup = new FormGroup({
    id: new FormControl(""),
    description: new FormControl(null, [Validators.required]),
    key: new FormControl(null, [Validators.required]),
  });

  public selected: any = null;
  public questStatus = QUEST_STATUS;
  private _modalRef: any = null;
  public selectedMembers: Array<any> = null;
  public selectedQuests: Quests = null;
  public questsOption: Array<Quests> = [
    {
      name: 'like',
      type: 'like',
      message: 'Like a product post',
      expiry: 0,
    },
    {
      name: 'suggestion',
      type: 'suggest',
      message: 'Make a suggestion for product',
      expiry: 0,
    },
    {
      name: 'report',
      type: 'report',
      message: 'Report a error',
      expiry: 0,
    },
  ];
  public allSuggestions: Array<any> = [];
  public allReports: Array<any> = [];
  public selMenu = 'quest';
  public selSubMenu = 'create';
  public members: Array<any> = [];
  public totalMembers: Member[] = [];
  @ViewChildren(NgbdSortableHeader) headers: QueryList<NgbdSortableHeader>;
  public page = 1;
  public pageSize = 10;
  public quests: Array<any> = [];
  public totalQuestList: Array<any> = [];
  public questPage = 1;
  public questPageSize = 10;
  public customQuestMessage: string = '';
  public searchDate = new FormControl('');
  public commonModal: any;
  public questList: Array<any> = [];

  /**
   * Constructor
   */
  constructor(
    private toastr: ToastrService,
    private auth: AuthServiceService,
    private fb: FormBuilder,
    private spinner: NgxSpinnerService,
    private commonService: CommonService,
    private modalService: NgbModal
  ) {}

  ngOnInit(): void {
    this._getMembersDetails();
    this._getQuestsList();

    this._getList();
   // this._getAllMemberRoleLevel();
   this.auth.getAllMemberLevelsRelationship().subscribe((resp: ApiResponse) => {
    this.optionsQuestLevel = this.options = {
      floor: 0,
      ceil: resp.body.length || 0,
      translate: (value: number, label: LabelType): string => {
        switch (label) {
          case LabelType.Low:
            return '<b>Level:</b>' + value;
          case LabelType.High:
            return '<b>Level:</b>' + value;
          default:
            return '' + value;
        }
      },
    };

  })
  }

  /**
   * get member details based on created date - dateCreated
   */
  private _getMembersDetails(): void {
    this.auth.getMembersDetails().subscribe((response: ApiResponse) => {
      this.totalMembers = response?.body || [];
      this.nextPage();
    });
  }

  public selectSubMenu(menu: string) {
    this.selSubMenu = menu;
  }

  public selectMenu(menu: string) {
    this.selMenu = menu;
  }

  public onSort({ column, direction }: SortEvent): void {
    // resetting other headers - do later
    for (const header of this.headers) {
      if (header.sortable !== column) {
        header.direction = '';
      }
    }

    // sorting countries
    if (direction === '' || column === '') {
      this.nextPage();
    } else {
      this.members = [...this.totalMembers].sort((a, b) => {
        const res = this._compare(a[column], b[column]);
        return direction === 'asc' ? res : -res;
      });
    }
  }

  public questNextPage(): void {
    this.quests = this.totalQuestList.slice(
      (this.questPage - 1) * this.questPageSize,
      (this.questPage - 1) * this.questPageSize + this.questPageSize
    );
  }

  public nextPage(): void {
    this.members = this.totalMembers.slice(
      (this.page - 1) * this.pageSize,
      (this.page - 1) * this.pageSize + this.pageSize
    );
  }

  private _compare(v1: string | number, v2: string | number) {
    return v1 < v2 ? -1 : v1 > v2 ? 1 : 0;
  }

  public selectTypeOfQuests(model) {
    this.selectedMembers = this.members.filter((i) => i.check);
    if (this.selectedMembers && this.selectedMembers.length > 0) {
      this._modalRef = this.modalService.open(model, {
        size: 'sm',
        ariaLabelledBy: 'modal-basic-title',
        windowClass: 'suggestion',
      });
    } else {
      this.toastr.error('Select atlist one member!');
    }
  }

  public sendQuests() {
    if (
      this.selectedQuests &&
      this.selectedMembers &&
      this.selectedMembers.length > 0
    ) {
      if (this.selectedQuests.name == 'custom') {
        if (!this.customQuestMessage) {
          this.toastr.error('Enter custom message!');
          return;
        }
        this.selectedQuests.message = this.customQuestMessage;
      }

      let payload = this.selectedMembers.map((i: any) => {
        return {
          userId: i.id,
          message: this.selectedQuests.message,
          expireAt: this.selectedQuests.expiry,
          type: this.selectedQuests.type,
        };
      });

      this.auth.createQuest(payload).subscribe((response: ApiResponse) => {
        this.toastr.success(response.message);
        this._modalRef.close();
        this._getQuestsList();
      });
    } else {
      this.toastr.error('Select one of Quest Type!');
    }
  }

  public selectQuest(key: string) {
    if (key == 'custom') {
      this.selectedQuests = {
        type: 'basic',
        expiry: 0,
        name: 'custom',
        message: '',
      };
    } else {
      this.selectedQuests =
        this.questsOption.find((i) => i.name == key) || null;
    }

    this.selectedQuests.expiry = this.selectedQuests.expiry
      ? new Date(this.selectedQuests.expiry).getTime()
      : null; // Need to update this login add days to date
  }

  public selectMember(member,isChecker:boolean) {
    this.members = this.members.map((i: any) => {
      if (member.id == i.id) {
        if (i?.check == true) {
          i.check = isChecker;
        } else {
          i['check'] = isChecker;
        }
      }
      return i;
    });
  }

  private _getQuestsList() {
    this.auth.getQuestList().subscribe((response: ApiResponse) => {
      this.totalQuestList = response.body;
      this.questNextPage();
    });
  }

  public onLevelChange() {
    this.members = this.totalMembers.filter(
      (i: any) => i.level >= this.value && this.value <= this.highValue
    );
  }

  public searchQuestBaseOnMember(text: string, prop: string) {
    this.quests = this.totalQuestList.filter((member) => {
      const term = text.toLowerCase();

      if (prop == 'phone') {
        return (member?.appUser?.phone || '').toLowerCase().includes(term);
      } else {
        return ((member?.[prop]).toString() || '').toLowerCase().includes(term);
      }
    });
  }

  public searchByDate(dateRange: Array<any>): void {
    if (dateRange && dateRange[0] && dateRange[1]) {
      this.quests = this.totalQuestList.filter((member) => {
        if (member.createdAt) {
          const targetDate = new Date(member.createdAt);
          return targetDate >= dateRange[0] && targetDate <= dateRange[1];
        } else {
          return false;
        }
      });
    }
  }

  // ******* NEW ************
  
  private _getList() {
    this.auth.getAllMemberQuestLevel().subscribe((resp: ApiResponse) => {
      this.questList = resp.body.map((i) => {

        let levels = i.questLevels.map(i => i.levelID);

        let max = levels.length == 0 ? 1 : Math.max(...levels) || 1;
        let min = levels.length == 0 ? 1 : Math.min(...levels) || 1;

        return {
          questId: i?.questId,
          description: i?.description,
          level: levels,
          maxLevel: max,
          minLevel: min,
          questKey: i?.questKey,
        };
      });

    })
  }


  public add(modal: any, selected: any = null) {
    if (selected) {
      this.form.patchValue({
        description: selected?.description,
        key: selected?.questKey.toUpperCase(),
      })
      this.selected = selected;
    } else {
      this.selected = null;
      this.form.reset();
    }
    this.commonModal = this.modalService.open(modal, { size: "sm", ariaLabelledBy: "modal-basic-title", backdrop: "static" });
  }


  public addQuest() {
    if (this.form.valid) {
      let payload = {
        description:this.form.get("description").value,
        key:this.form.get("key").value.toUpperCase()
      }
      if (this.selected) {
        payload['questId'] = this.selected?.questId;
      }

      this.auth.addMemberQuest(payload).subscribe((resp: ApiResponse) => {
        this.toastr.success(resp.message);
        this.commonModal.close();
        this._getList();
        this.selected = null;
      })
    }else{
      this.toastr.error("Invalid Form!")
    }
  }


  public deleteQuest(selected: any) {
    this.auth.deleteMemberQuest(selected).subscribe((resp: ApiResponse) => {
      this._getList();
    }, ({ error }: any) => {
      this.toastr.error(error.message);
    })
  }

  public saveLevel(selected: any) {
    this.auth.updateBulkLevelsToQuest({ questId: selected?.questId, levelIDs: [...Array(selected.maxLevel + 1).keys()].slice(selected.minLevel) }).subscribe((resp: ApiResponse) => {
      this._getList();
      this.toastr.success(resp.message);
    }, ({ error }: any) => {
      this.toastr.error(error.message);
    });
  }
}
